export * from 'b2b-apps/core/cart/components/CartSummary/Skeleton';
